import { IObservable, Subject } from '~/rage/utils';
import { IHudWeather, WeatherType } from '~/shared';
import { VarsService } from '../VarsService';
import { IWeatherService } from './weatherServiceTypes';

export class WeatherService implements IWeatherService {
	private weather = new Subject<IHudWeather>({
		weather: WeatherType.EXTRASUNNY,
		degrees: 20,
	});

	constructor(private readonly vars: VarsService) {
		this.vars
			.get('weather', {
				weather: WeatherType.EXTRASUNNY,
				degrees: 20,
			})
			.subscribe((weather) => {
				this.weather.next(weather);
			});
	}

	public getWeather(): IObservable<IHudWeather> {
		return this.weather;
	}
}
